import { ArticleRounded } from "@mui/icons-material"
import { IconButton } from "@mui/material"
import dayjs from "dayjs"
import { LocalAtmRounded } from "resource/muiImport"
import { numberFormat } from "utils"

export const columns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: (params) => {
      return params.id === 0? null: (
        <IconButton size="small" >
          <ArticleRounded color="primary" />
        </IconButton>
      )
    }
  },
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "LicNm",
    headerName: "ทะเบียน",
    width: 100,
  },
  {
    field: "DrvNm",
    headerName: "พนักงานขับรถ",
    width: 165,
  },
  {
    field: "NumJo",
    headerName: "จำนวนเที่ยว",
    width: 90,
    align: "center"
  },
  {
    field: "DrvFixCost",
    headerName: "เงินเดือน พขร.",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-orange',
  },
  {
    field: "TripAmnt",
    headerName: "ค่าเที่ยว พขร",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-orange',
  },
  {
    field: "E1000Amnt",
    headerName: "ค่าน้ำมัน",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-orange',
  },
  {
    field: "E88Amnt",
    headerName: "ค่า ซ่อมตู้",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-orange',
  },
  {
    field: "E98Amnt",
    headerName: "ค่า ซ่อมรถ",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-orange',
  },
  {
    field: "ItmOthOwnRcptAmnt",
    headerName: "ต้นทุนอื่นๆ",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-orange',
  },
  {
    field: "ItmCusRcptAmnt",
    headerName: "ซื้อใบเสร็จลูกค้า",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-orange',
  },
  {
    field: "ScInvOwnRcptAmnt",
    headerName: "วางบิลรถร่วม(ใบเสร็จบริษัท)",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-deepOrange',
  },
  {
    field: "ScInvCusRcptAmnt",
    headerName: "วางบิลรถร่วม(ใบเสร็จลูกค้า)",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-deepOrange',
  },
  {
    field: "ScInvTotal",
    headerName: "วางบิลรถร่วม(รวม)",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-deepOrange',
  },
  {
    field: "CostTotal",
    headerName: "รวมต้นทุน",
    width: 130,
    align: 'right',
    valueGetter: ({ row }) => +(row.DrvFixCost ?? 0) + +(row.TripAmnt ?? 0)
      + +(row.ItmOthOwnRcptAmnt ?? 0) + +(row.E1000Amnt ?? 0) + +(row.E88Amnt ?? 0)
      + +(row.E98Amnt ?? 0) + +(row.ScInvOwnRcptAmnt ?? 0),
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-red',
  },
  {
    field: "InvTransAmnt",
    headerName: "รายได้ค่าขนส่ง",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-green',
  },
  {
    field: "InvOthOwnRcptAmnt",
    headerName: "รายได้อื่นๆ",
    width: 130,
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-green',
  },
  {
    field: "InvOwnRcptAmnt",
    headerName: "รวมรายได้",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-green',
  },
  {
    field: "InvCusRcptAmnt",
    headerName: "ขายใบเสร็จลูกค้า",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-green',
  },
  {
    field: "InvTotal",
    headerName: "รวมยอดแจ้งหนี้",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-green',
  },
  {
    field: "Profit",
    headerName: "กำไรเบื้องต้น",
    width: 130,
    align: 'right',
    valueGetter: ({ row }) => +(row.InvOwnRcptAmnt ?? 0) - (+(row.DrvFixCost ?? 0) + +(row.TripAmnt ?? 0)
      + +(row.ItmOthOwnRcptAmnt ?? 0) + +(row.E1000Amnt ?? 0) + +(row.E88Amnt ?? 0)
      + +(row.E98Amnt ?? 0)),
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: ({value}) => value > 0 ? 'cell-greenMore' : 'cell-red',
  },
  {
    field: "TripAmntPerJo",
    headerName: "ค่าเที่ยว/เที่ยว",
    width: 130,
    align: 'right',
    valueGetter: ({ row }) => row.NumJo === 0 ? "" : row.TripAmnt / +row.NumJo,
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
  },
]

export const detailColumns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: ({id}) => {
      return id===0? null: (
        <IconButton size="small" >
          <ArticleRounded color="primary" />
        </IconButton>
      )
    }
  },
  {
    field: 'ShowDetailExpense',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: ({id}) => {
      return id===0? null: (
        <IconButton size="small" >
          <LocalAtmRounded color="primary" />
        </IconButton>
      )
    }
  },
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "LicNm",
    headerName: "ทะเบียน",
    width: 100,
  },
  {
    field: "DrvNm",
    headerName: "พนักงานขับรถ",
    width: 150,
  },
  {
    field: "JobOrdId",
    headerName: "เลขที่ใบงาน",
    width: 120,
  },
  {
    field: "AptTm",
    headerName: "วันที่นัด",
    width: 110,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM/YYYY") : "-";
    },
  },
  {
    field: "ContNo",
    headerName: "หมายเลขตู้",
    width: 120,
  },
  {
    field: "Loc",
    headerName: "สถานที่",
    valueGetter: ({ id, row }) => id === 0 ? "" : `${row.TakePlc} - ${row.Loc} - ${row.RtnPlc}`,
    flex: 1,
    minWidth: 200,
  },
  {
    field: "DrvFixCost",
    headerName: "เงินเดือน พขร.",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-orange',
  },
  {
    field: "TripAmnt",
    headerName: "ค่าเที่ยว พขร",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-orange',
  },
  {
    field: "E1000Amnt",
    headerName: "ค่าน้ำมัน",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-orange',
  },
  {
    field: "E88Amnt",
    headerName: "ค่า ซ่อมตู้",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-orange',
  },
  {
    field: "E98Amnt",
    headerName: "ค่า ซ่อมรถ",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-orange',
  },
  {
    field: "ItmOthOwnRcptAmnt",
    headerName: "ต้นทุนอื่นๆ",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-orange',
  },
  {
    field: "ItmCusRcptAmnt",
    headerName: "ซื้อใบเสร็จลูกค้า",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-orange',
  },
  {
    field: "ScInvOwnRcptAmnt",
    headerName: "วางบิลรถร่วม(ใบเสร็จบริษัท)",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-deepOrange',
  },
  {
    field: "ScInvCusRcptAmnt",
    headerName: "วางบิลรถร่วม(ใบเสร็จลูกค้า)",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-deepOrange',
  },
  {
    field: "ScInvTotal",
    headerName: "วางบิลรถร่วม(รวม)",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-deepOrange',
  },
  {
    field: "CostTotal",
    headerName: "รวมต้นทุน",
    width: 130,
    align: 'right',
    valueGetter: ({ row }) => +(row.DrvFixCost ?? 0) + +(row.TripAmnt ?? 0)
      + +(row.ItmOthOwnRcptAmnt ?? 0) + +(row.E1000Amnt ?? 0) + +(row.E88Amnt ?? 0)
      + +(row.E98Amnt ?? 0) + +(row.ScInvOwnRcptAmnt ?? 0),
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-red',
  },
  {
    field: "InvTransAmnt",
    headerName: "รายได้ค่าขนส่ง",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-green',
  },
  {
    field: "InvOthOwnRcptAmnt",
    headerName: "ใบเสร็จบริษัทอื่น",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-green',
  },
  {
    field: "InvOwnRcptAmnt",
    headerName: "รวมใบเสร็จบริษัท",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-green',
  },
  {
    field: "InvCusRcptAmnt",
    headerName: "ขายใบเสร็จลูกค้า",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-green',
  },
  {
    field: "InvTotal",
    headerName: "รวมยอดแจ้งหนี้",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: 'cell-green',
  },
  {
    field: "Profit",
    headerName: "กำไรเบื้องต้น",
    width: 130,
    align: 'right',
    valueGetter: ({ row }) => +(row.InvOwnRcptAmnt ?? 0) - (+(row.DrvFixCost ?? 0) + +(row.TripAmnt ?? 0)
      + +(row.ItmOthOwnRcptAmnt ?? 0) + +(row.E1000Amnt ?? 0) + +(row.E88Amnt ?? 0)
      + +(row.E98Amnt ?? 0)),
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
    cellClassName: ({value}) => value > 0 ? 'cell-greenMore' : 'cell-red',
  },
]

export const expenseDetailColumns = [
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "IsOwnRcpt",
    headerName: "ประเภทใบเสร็จ",
    width: 100,
    align: 'center',
    valueGetter: ({ id, value }) => id === 0 ? null : value === 1 ? "บริษัท" : "ลูกค้า",
    cellClassName: ({id, row}) => id === 0 ? null : row.IsOwnRcpt === 1 ? 'cell-green' : 'cell-blue',
  },
  {
    field: "ExpNm",
    headerName: "รายการ",
    flex: 1,
  },
  {
    field: "Total",
    headerName: "ราคา",
    width: 100,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "0.0" : numberFormat(value),
  },
]